module.exports = __webpack_public_path__ + "img/logo.b5b1477f.png";